<template>
  <nav class="navbar navbar-expand-lg" style="background-color: #3d405b !important;height: 50px !important;">
    <div class="container" style="padding-left: 15px;padding-right: 15px;">
      <a class="navbar-brand d-flex align-items-center" href="javascript:void(0)">
        <img :src="folder_slider + foto_background" alt="Siberbi"
          style="width: 150px;position: absolute !important;top: 10px;" v-if="(bahasa === null) || (bahasa == 'ina')">
        <img :src="folder_slider + foto_background" alt="Siberbi"
          style="width: 150px;position: absolute !important;top: 10px;" v-else>
      </a>
      <div class="d-lg-none ms-auto me-3">
        <a class="btn custom-btn custom-border-btn" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button"
          aria-controls="offcanvasExample">
          <span v-if="(bahasa === null) || (bahasa == 'ina')">Masuk</span>
          <span v-else>Login</span>
        </a>
      </div>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-lg-auto">
          <li>
            <a :class="[((route.name == 'Beranda') ? 'nav-link click-scroll active' : 'nav-link click-scroll')]"
              href="/">
              <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
              <span v-else>Home</span>
            </a>
          </li>

          <li>
            <a :class="[((route.name == 'DaftarKonten') ? 'nav-link click-scroll active' : 'nav-link click-scroll')]"
              href="/DaftarKonten">
              <span v-if="(bahasa === null) || (bahasa == 'ina')">Tentang SIBERBI</span>
              <span v-else>About SIBERBI</span>
            </a>
          </li>

          <li>
            <a :class="[((route.name == 'DaftarBerita' || route.name == 'ListBerita') ? 'nav-link click-scroll active' : 'nav-link click-scroll')]"
              href="/DaftarBerita">
              <span v-if="(bahasa === null) || (bahasa == 'ina')">Simulasi Investasi</span>
              <span v-else>Invesment Simulation</span>
            </a>
          </li>
        </ul>
        <div class="d-none d-lg-block ms-lg-3">
          <a class="btn custom-btn custom-border-btn" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button"
            aria-controls="offcanvasExample">
            <span v-if="(bahasa === null) || (bahasa == 'ina')">Masuk</span>
            <span v-else>Login</span>
          </a>
        </div>
        <div class="d-none d-lg-block ms-lg-3 text-center" style="cursor: pointer;">
          <img src="../../../../../src/assets/images/ina_active.jpg" height="20" alt="Indonesia"
            v-if="(bahasa === null) || (bahasa == 'ina')" @click="gantibahasa('ina')">&nbsp;
          <img src="../../../../../src/assets/images/ina.jpg" height="20" alt="Indonesia" v-else
            @click="gantibahasa('ina')">&nbsp;
          <img src="../../../../../src/assets/images/eng_active.jpg" height="20" alt="English"
            @click="gantibahasa('eng')" v-if="(bahasa == 'eng')">
          <img src="../../../../../src/assets/images/eng.jpg" height="20" alt="English" @click="gantibahasa('eng')"
            v-else>
        </div>

      </div>
    </div>
  </nav>
  <div class="offcanvas offcanvas-end" data-bs-scroll="true" tabindex="-1" id="offcanvasExample"
    aria-labelledby="offcanvasExampleLabel">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel">
        <span v-if="(bahasa === null) || (bahasa == 'ina')">Masuk</span>
        <span v-else>Login</span>
      </h5>

      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>

    <div class="offcanvas-body d-flex flex-column">
      <div class="member-login-form-body">
        <div class="mb-4">
          <label class="form-label mb-2" for="username">Username</label>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Username" id="username" name="username"
              :isFilled="true" v-model="username">
            <div class="input-group-append">
              <button type="button" class="btn">
                <i class="fas fa-arrow-right text-muted"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <label class="form-label mb-2" for="password">Password</label>
          <div class="input-group">
            <input :type="[showPassword ? 'text' : 'password']" class="form-control" placeholder="Password"
              name="password" id="password" :isFilled="true" v-model="password">
            <div class="input-group-append">
              <button type="button" class="btn" @click="toggleShow">
                <i :class="{ 'fas fa-eye-slash text-muted': showPassword, 'fas fa-eye text-muted': !showPassword }"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <label class="form-label mb-2" for="capcha">Captcha</label>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Captcha" id="capcha" name="capcha" :isFilled="true"
              v-model="capcha" disabled style="background-color: #cccccc;">
            <div class="input-group-append">
              <button type="button" class="btn">
                <i class="fas fa-key text-muted"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <label class="form-label mb-2" for="capchainput">Input Captcha</label>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Input Captcha" id="capchainput" :isFilled="true"
              name="capchainput" v-model="capchainput" @click.right.prevent @keydown="keydown" @copy.prevent
              @paste.prevent style="text-transform:uppercase">
            <div class="input-group-append">
              <button type="button" class="btn">
                <i class="fas fa-key text-muted"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="form-check mb-4">
          <input class="form-check-input" type="checkbox" value="" id="customSwitchAuth" @click="rubahisi()">
          <label class="form-check-label" for="customSwitchAuth">
            <span v-if="(bahasa === null) || (bahasa == 'ina')">Autentifikasi</span>
            <span v-else>Authentication</span>
          </label>
        </div>
        <div class="col-lg-5 col-md-7 col-8 mx-auto">
          <button type="submit" class="form-control btn custom-btn" :disabled="showHuman == false"
            v-on:click="loginAct">
            <span v-if="(bahasa === null) || (bahasa == 'ina')">Masuk</span>
            <span v-else>Login</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';

export default {
  setup() {
    const route = useRoute()
    watch(() => route.name, () => {
    });

    return { route };
  },
  components: {
    swal
  },
  data() {
    return {
      tahun: new Date().getFullYear(),
      bahasa: localStorage.getItem("bahasasistem"),
      secretencData: '',
      username: "", password: "",
      showHuman: false,
      showPassword: false,
      capcha: this.makeid(5),
      capchainput: '',
      project_id: process.env.VUE_APP_PROJECT_ID,
      folder_slider: process.env.VUE_APP_URL_API + 'parastapainnovation_slider-Gambar?f=',
      foto_background: '',
      datapesan: '',
      programandbudgeting: false,
      keuangan: false,
      pengadaan: false,
      kegiatanproyek: false,
      social: false,
      environmental: false,
      gender: false,
      menumonitoring: [],
      bytes: encodeURIComponent(CryptoJS.AES.encrypt('Kosong', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
    };
  },
  methods: {
    gantibahasa(bahasanya) {
      localStorage.setItem("bahasasistem", bahasanya);
      location.reload();
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    async ambilgambar() {
      const mainAPI = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
        },
      });
      if ((this.bahasa === null) || (this.bahasa == 'ina')) {
        var idgambar = '11';
      }
      else {
        var idgambar = '12';
      }
      var random = Math.random();
      await mainAPI.get("parastapainnovation-GetSlider?random=" + random + "&project_id=" + this.project_id + "&id=" + idgambar).then(
        Response => {
          this.datapesan = Response.data.message;
          if (this.datapesan == 'data diketemukan') {
            this.foto_background = Response.data.content.data[0].filenya_slider;
          }
          else {
            this.foto_background = '';
          }
        }
      ).catch(error => {
        this.datapesan = '';
        this.foto_background = '';
        this.dataslider = [];
      });

      await mainAPI.get("getmenu-Menu?random=" + random + "&project_id=" + this.project_id).then(
        Response => {
          this.datapesan = Response.data.message;
          if (this.datapesan == 'data diketemukan') {
            this.menumonitoring = Response.data.content.data;
            for (let i = 0; i < this.menumonitoring.length; i++) {
              if (this.menumonitoring[i].id == '1') {
                if (this.menumonitoring[i].tampil == '0') {
                  this.programandbudgeting = false;
                }
                else {
                  this.programandbudgeting = true;
                }
              }
              if (this.menumonitoring[i].id == '2') {
                if (this.menumonitoring[i].tampil == '0') {
                  this.keuangan = false;
                }
                else {
                  this.keuangan = true;
                }
              }
              if (this.menumonitoring[i].id == '3') {
                if (this.menumonitoring[i].tampil == '0') {
                  this.pengadaan = false;
                }
                else {
                  this.pengadaan = true;
                }
              }
              if (this.menumonitoring[i].id == '4') {
                if (this.menumonitoring[i].tampil == '0') {
                  this.kegiatanproyek = false;
                }
                else {
                  this.kegiatanproyek = true;
                }
              }
              if (this.menumonitoring[i].id == '5') {
                if (this.menumonitoring[i].tampil == '0') {
                  this.social = false;
                }
                else {
                  this.social = true;
                }
              }
              if (this.menumonitoring[i].id == '6') {
                if (this.menumonitoring[i].tampil == '0') {
                  this.environmental = false;
                }
                else {
                  this.environmental = true;
                }
              }
              if (this.menumonitoring[i].id == '7') {
                if (this.menumonitoring[i].tampil == '0') {
                  this.gender = false;
                }
                else {
                  this.gender = true;
                }
              }
            }
          }
          else {
            this.menumonitoring = [];
          }
        }
      ).catch(error => {
        this.datapesan = '';
        this.menumonitoring = [];
      });
    },
    rubahisi() {
      if ((this.showHuman == false) && (this.capcha == this.capchainput.toUpperCase())) {
        if (this.username.length == 0) {
          this.showHuman = false;
          document.getElementById("customSwitchAuth").checked = false;
          swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).fire({
            icon: 'warning',
            title: 'Isikan username',
          });
          return false;
        }
        if (this.password.length == 0) {
          document.getElementById("customSwitchAuth").checked = false;
          this.showHuman = false;
          swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).fire({
            icon: 'warning',
            title: 'Isikan password',
          });
          return false;
        }
        this.showHuman = true;
      }
      else {
        if (this.capcha != this.capchainput.toUpperCase()) {
          document.getElementById("customSwitchAuth").checked = false;
          this.showHuman = false;
          swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).fire({
            icon: 'warning',
            title: 'Kode keamanan tidak sama',
          });
        }
        this.showHuman = false;
      }
    },
    async loginAct() {

      const mainAPIIP = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
        },
      });
      var random = Math.random();

      await mainAPIIP.get("parastapainnovationip-Key?random=" + random).then(
        Response => {
          this.datapesan = Response.data.message;
          if (this.datapesan == 'data diketemukan') {
            this.ipnya = Response.data.randkey;
          }
          else {
            this.ipnya = '';
          }
          this.halamanloading = false;
        }
      ).catch(error => {
        this.datapesan = "";
        console.log(error);
      });

      const data = {
        username: this.username,
        katakunci: this.password,
        ipnya: this.ipnya,
        project_id: this.project_id,
      };


      if ((this.username == "") || (this.password == "")) {
        swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          icon: 'warning',
          title: 'Isikan kolom secara lengkap..',
        });
        document.getElementById('customSwitchAuth').checked = false;
        document.getElementById("username").focus();
        this.showHuman = false;
        return false;
      }

      const mainAPI = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      await mainAPI.post("parastapainnovation-login", data).then(
        Response => {
          if (Response.data.response == 'error') {
            swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              icon: 'warning',
              title: Response.data.message,
            });
            this.showHuman = false;
            document.getElementById('customSwitchAuth').checked = false;
            return false;

          }
          else {
            const mainAPIUser = axios.create({
              baseURL: process.env.VUE_APP_URL_API,
              headers: {
                Authorization: "Bearer " + Response.data.accessToken,
              },
            });
            mainAPIUser.get("parastapainnovation-GetDataUserName?random=" + random + "&kduser=" + Response.data.content.data[0].username + "&level=" + Response.data.content.data[0].id_user_level + "&project_id=" + this.project_id).then(
              Res => {
                if (Res.data.response == 'error') {
                  swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                  }).fire({
                    icon: 'warning',
                    title: Res.data.message,
                  });
                  document.getElementById("username").focus();
                  this.showHuman = false;
                  document.getElementById('customSwitchAuth').checked = false;
                  return false;

                }
                else {
                  localStorage.setItem("tokensistem", JSON.stringify(Response.data.accessToken));
                  localStorage.setItem("isistem", JSON.stringify(Res.data.content.data[0].id));
                  localStorage.setItem("usistem", JSON.stringify(Res.data.content.data[0].username));
                  localStorage.setItem("lsistem", JSON.stringify(Res.data.content.data[0].id_user_level));
                  localStorage.setItem("inssistem", JSON.stringify(Res.data.content.data[0].id_instansi));
                  localStorage.setItem("emlsistem", JSON.stringify(Res.data.content.data[0].email));
                  localStorage.setItem("nmusistem", JSON.stringify(Res.data.content.data[0].nama));
                  localStorage.setItem("imgsistem", JSON.stringify(Res.data.content.data[0].gambar));
                  localStorage.setItem("tsistem", new Date().toString());
                  this.showHuman = false;
                  window.location.replace("/Dashboard");
                }
              }
            ).catch(
              error => {
                swal.mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000
                }).fire({
                  icon: 'warning',
                  title: error,
                });
                this.showHuman = false;
                document.getElementById('customSwitchAuth').checked = false;
                return false;
              }
            )
          }
        }
      ).catch(
        error => {
          swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).fire({
            icon: 'warning',
            title: error,
          });
          this.showHuman = false;
          document.getElementById('customSwitchAuth').checked = false;
          return false;
        }
      )
    },
  },
  mounted() {
    try {
      this.secretencData = decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8));
    } catch (error) {
    }
    this.ambilgambar();
  },
}
</script>

<style></style>